import { deleteCookie } from "./cookies";
import { deleteLocalStorage, setLocalStorage } from "./localStorage";

//Callback function
export const logout = () => {
  deleteCookie("token");
  deleteLocalStorage("userData");
  deleteLocalStorage("selectedAcademicYear");
};

export const formatPermissions = (permissions: any) => {
  // Formatter les permissions
  const formattedPermissions = Object.entries(permissions).flatMap(
    ([feature, actions]) =>
      (actions as string[]).map((action: string) => `${feature}:${action}`),
  );
  return formattedPermissions || [];
};

// Génère un identifiant unique pour chaque appareil
export const generateDeviceID = () => {
  // 1. Navigateur moderne / React Native récent
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    const uuidUnique = crypto.randomUUID(); // Généré UNE SEULE FOIS
    setLocalStorage("deviceID", uuidUnique);
    return uuidUnique; // On retourne EXACTEMENT le même
  }

  // 2. Fallback universel hautement résistant aux doublons
  const horodatage = Date.now().toString(36);
  // On génère deux blocs aléatoires au lieu d'un seul pour éliminer le risque de collision
  const aleatoire1 = Math.random().toString(36).substring(2, 10);
  const aleatoire2 = Math.random().toString(36).substring(2, 10);

  const device_id = `${horodatage}-${aleatoire1}-${aleatoire2}`;

  setLocalStorage("deviceID", device_id);
  return device_id;
};
